import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import {
  getAuthState,
  getOnboardingState,
  getCareerResults,
  getUserHasRegistered,
  getAuthUserId,
} from '../../store/selectors';
import {
  setUser,
  setAuthStatus,
  getTopMatches,
  getUserData,
  getCurrentUserId,
  getData,
} from '../../store/actions';
import RegisterWithRouter from '../auth/Register';
import CampusBackground from '../CampusBackground';
import ModalController from '../utility/modal/ModalController';
import ScrollComponent from '../utility/ScrollComponent';
import BrightOutlookModal from '../utility/modal/BrightOutlookModal.jsx';
import Loading from '../utility/Loading';
import Fade from '../utility/Fade';

const bars = {
  Onboarding: {
    current: 100,
    override: false,
  },
  'Picture Game': {
    current: 100,
    override: false,
  },
  'Career Path': {
    current: 15,
    override: false,
  },
};

class RegisterTopCareersFlow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // awful name, but it's standard to react-transition-group
      inProp: true,
      showBrightOutlookModal: false,
    };
  }

  get jwtToken() {
    return this.props.auth.jwtToken;
  }

  get onboarding() {
    return this.props.onboarding;
  }

  get isAuthenticated() {
    return this.props.auth.isAuthenticated;
  }

  get authUser() {
    return this.props.auth.user;
  }

  get onboardingUser() {
    return this.onboarding.userData.user;
  }

  get userCareerGameResults() {
    return this.props.userCareerGameResults;
  }

  get userHasRegistered() {
    return this.props.userHasRegistered;
  }

  get authUserId() {
    return this.props.authUserId;
  }

  async componentDidMount() {
    if (this.jwtToken) {
      const userId = await this.props.getCurrentUserId(this.jwtToken);
      if (userId) {
        await this.props.getUserData(userId, this.jwtToken);
        await this.props.getData(userId, this.props.auth.jwtToken);
      }
    }
  }

  renderRightContent = () => {
    // Really restrict the registration page to stop flashing after registering
    if (
      !this.authUserId &&
      !this.userHasRegistered &&
      this.userCareerGameResults.length === 0
    ) {
      return (
        <RegisterWithRouter
          setBrightOutlookModal={this.setBrightOutlookModal}
          bars={bars}
        />
      );
    }
    return <Loading height="100%" />;
  };

  primaryBorderTop = {
    borderTop: `5px solid ${this.props.tenant.primary}`,
    height: '100%',
  };

  secondaryBorder = {
    borderBottom: `5px solid ${this.props.tenant.secondary}`,
  };

  setBrightOutlookModal = () => {
    this.setState((prevState) => ({
      showBrightOutlookModal: !prevState.showBrightOutlookModal,
    }));
  };

  render() {
    return (
      <>
        {this.state.showBrightOutlookModal && (
          <BrightOutlookModal
            tenant={this.props.tenant}
            onClickParent={this.setBrightOutlookModal}
          />
        )}
        <ScrollComponent />
        <CampusBackground secondaryColor={this.props.tenant.secondary} column>
          <div
            className="column-register-top-career"
            style={this.primaryBorderTop}
          >
            <div
              className={classNames({
                'authenticated-top-content': this.props.auth.isAuthenticated,
                'top-content': !this.props.auth.isAuthenticated,
              })}
              style={{ height: '100%' }}
            >
              <Fade in={this.state.inProp}>{this.renderRightContent()}</Fade>
            </div>
          </div>
        </CampusBackground>
        <ModalController />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);
  const userCareerGameResults = getCareerResults(state);
  const userHasRegistered = getUserHasRegistered(state);
  const authUserId = getAuthUserId(state);

  return {
    auth,
    onboarding,
    userCareerGameResults,
    userHasRegistered,
    authUserId,
  };
};

const registerTopCareersFlowWithRouter = withRouter(
  connect(mapStateToProps, {
    setAuthStatus,
    setUser,
    getTopMatches,
    getUserData,
    getCurrentUserId,
    getData,
  })(RegisterTopCareersFlow)
);

RegisterTopCareersFlow.propTypes = {
  tenant: PropTypes.object.isRequired,
};

export default registerTopCareersFlowWithRouter;
